import { Component } from '@angular/core';

@Component({
  selector: 'app-purchase-order-form',
  standalone: false,
  templateUrl: './purchase-order-form.component.html',
  styleUrl: './purchase-order-form.component.scss',
})
export class PurchaseOrderFormComponent {}
